import * as React from 'react';
export const pulleySvg = React.forwardRef(function pulleySvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#347C5F',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.5 24h3.977v-4.969h2.7c3.769 0 6.123-2.172 6.123-5.492C23.3 10.25 20.994 8 17.298 8H10.5v16Zm3.977-8.016v-4.867h1.961c1.784 0 2.74.938 2.74 2.422 0 1.477-.956 2.445-2.74 2.445h-1.96Z',
      fill: '#fff',
    }),
  );
});
pulleySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var pulley = {
  category: 'brand',
  colorable: false,
  name: 'pulley',
  svg: pulleySvg,
};
